// Helper for building Logo.dev image URLs. Logo.dev is a frontend-only
// connector: the publishable key is exposed as a VITE_ env var and used
// directly against img.logo.dev (never api.logo.dev, which needs a secret key).
const TOKEN = import.meta.env.VITE_LOVABLE_CONNECTOR_LOGO_DEV_API_KEY as
  | string
  | undefined;

/**
 * Build a Logo.dev image URL for a company domain.
 * Falls back to a clean monogram when no logo is found, so the grid never
 * shows broken images.
 */
export function logoUrl(domain: string, size = 96): string {
  if (!TOKEN) return "";
  const params = new URLSearchParams({
    token: TOKEN,
    size: String(size),
    format: "png",
    retina: "true",
    fallback: "monogram",
  });
  return `https://img.logo.dev/${domain}?${params.toString()}`;
}

export const hasLogoToken = Boolean(TOKEN);
